var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJustMeCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3119_3595)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 40C0 62.09 17.91 80 40 80C62.09 80 80 62.09 80 40C80 17.91 62.09 0 40 0C17.91 0 0 17.91 0 40Z",
    fill: "#E0E9FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1499 67.2798C12.1499 69.0598 24.9999 70.5098 40.8499 70.5098C56.6999 70.5098 69.5499 69.0598 69.5499 67.2798C69.5499 65.4998 56.6999 64.0498 40.8499 64.0498C24.9999 64.0498 12.1499 65.4998 12.1499 67.2798Z",
    fill: "#2B6BF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3201 9.49023H69.6801V65.0102H10.3201V9.49023Z",
    fill: "white",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4399 15.9004H62.5499V52.2004H17.4399V15.9004Z",
    fill: "#2B6BF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4399 15.9004H62.5499V52.2004H17.4399V15.9004Z",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4401 52.2199C53.9801 43.9899 43.7701 39.8499 34.6201 42.9599C29.8701 44.5799 26.1201 47.9499 24.3201 52.2199H57.4401Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9101 30.9903C48.8501 34.9803 45.2001 38.1603 40.7701 38.1103C36.4201 38.0603 32.9201 34.9003 32.8601 30.9903V27.3803C32.9201 23.3903 36.5701 20.2103 41.0001 20.2603C45.3501 20.3103 48.8501 23.4703 48.9101 27.3803V30.9903Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9101 30.9903C48.8501 34.9803 45.2001 38.1603 40.7701 38.1103C36.4201 38.0603 32.9201 34.9003 32.8601 30.9903V27.3803C32.9201 23.3903 36.5701 20.2103 41.0001 20.2603C45.3501 20.3103 48.8501 23.4703 48.9101 27.3803V30.9903Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3119_3595"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJustMeCheckbox);
export default __webpack_public_path__ + "static/media/just-me-checkbox.8f247f4fd9ca0ae8ec1fc311b1bbb1f2.svg";
export { ForwardRef as ReactComponent };